import * as tagVideoActions from '../../action_creators/tag/tag_video_action_creators';
import TagVideoModel from '../../../models/tag/tag_video_module';
import log from '../../../services/logger_service';
import get from 'lodash/get';

const tagVideoLimit = 100;

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagVideoActions.tagVideoLoading({}, store));
    return TagVideoModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        const responseData = get(resp, 'data', {});
        if (get(responseData, 'playlist', []).length > tagVideoLimit) {
          responseData.playlist.length = tagVideoLimit - 1;
        }
        dispatch(tagVideoActions.tagVideoLoaded(responseData, store));
      })
      .catch(function handleUserError(err) {
        dispatch(tagVideoActions.tagVideoLoadError(err, store));
        log.error(err, `Error in tag video actions, message: ${err.message}`);
      });
  };
}
